import application from 'application/application';

const controller = 'DefaultEditTextEditorController';

import Quill from 'quill';

import Delta from 'quill-delta';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$element',
	'notification',
	($scope, $rootScope, $element, notification) => {
		$scope.limit = $element[0].getAttribute('limit');
		$scope.title = $element[0].getAttribute('title') || 'Observações';

		$rootScope.configQuill = {
			value: ''
		};

		var quill = {};
		var quillExpanded = {};

		// botoes de formatação
		$scope.formatQuill = (attribute, value, event, expanded) => {
			event.preventDefault();

			if (expanded) return;

			let currentQuill = expanded && quillExpanded ? quillExpanded : quill;

			$scope.activeAlign = value;

			currentQuill.format(attribute, value);
		};

		// verificar se tem um botao selecionado
		$scope.isActiveSelection = (align, expanded) => {
			if (expanded && !$scope.modalquillExpanded) return;

			return $scope.activeAlign == align;
		};

		// ajustar layouts e logos
		$scope.updateThemeQuill = () => {
			let buttons = [
				{
					class: 'ql-bold-button',
					classEx: 'ql-bold-button-ex',
					idRe: 'ql-bold-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="black">
					<path d="M11.4188 8.8425C12.1463 8.34 12.6562 7.515 12.6562 6.75C12.6562 5.055 11.3438 3.75 9.65625 3.75H4.96875V14.25H10.2487C11.8162 14.25 13.0312 12.975 13.0312 11.4075C13.0312 10.2675 12.3863 9.2925 11.4188 8.8425ZM7.21875 5.625H9.46875C10.0912 5.625 10.5938 6.1275 10.5938 6.75C10.5938 7.3725 10.0912 7.875 9.46875 7.875H7.21875V5.625ZM9.84375 12.375H7.21875V10.125H9.84375C10.4662 10.125 10.9688 10.6275 10.9688 11.25C10.9688 11.8725 10.4662 12.375 9.84375 12.375Z" fill-opacity="0.87"/>
					</svg>`
				},
				{
					class: 'ql-italic-button',
					classEx: 'ql-italic-button-ex',
					idRe: 'ql-italic-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="black">
					<path d="M7.5 3.75V6H9.1575L6.5925 12H4.5V14.25H10.5V12H8.8425L11.4075 6H13.5V3.75H7.5Z" fill-opacity="0.6"/>
					</svg>`
				},
				{
					class: 'ql-strike-button',
					classEx: 'ql-strike-button-ex',
					idRe: 'ql-strike-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="black">
					<path d="M7.5 14.625H10.5V12.375H7.5V14.625ZM3.75 3.375V5.625H7.5V7.875H10.5V5.625H14.25V3.375H3.75ZM2.25 10.875H15.75V9.375H2.25V10.875Z" fill-opacity="0.87"/>
					</svg>`
				},
				{
					class: 'ql-list-button',
					classEx: 'ql-list-button-ex',
					idRe: 'ql-list-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
					<path d="M1.875 12.75H3.375V13.125H2.625V13.875H3.375V14.25H1.875V15H4.125V12H1.875V12.75ZM2.625 6H3.375V3H1.875V3.75H2.625V6ZM1.875 8.25H3.225L1.875 9.825V10.5H4.125V9.75H2.775L4.125 8.175V7.5H1.875V8.25ZM5.625 3.75V5.25H16.125V3.75H5.625ZM5.625 14.25H16.125V12.75H5.625V14.25ZM5.625 9.75H16.125V8.25H5.625V9.75Z" fill="black" fill-opacity="0.6"/>
					</svg>`
				},
				{
					class: 'ql-bullet-button',
					classEx: 'ql-bullet-button-ex',
					idRe: 'ql-bullet-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
					<path d="M3.1875 7.875C2.565 7.875 2.0625 8.3775 2.0625 9C2.0625 9.6225 2.565 10.125 3.1875 10.125C3.81 10.125 4.3125 9.6225 4.3125 9C4.3125 8.3775 3.81 7.875 3.1875 7.875ZM3.1875 3.375C2.565 3.375 2.0625 3.8775 2.0625 4.5C2.0625 5.1225 2.565 5.625 3.1875 5.625C3.81 5.625 4.3125 5.1225 4.3125 4.5C4.3125 3.8775 3.81 3.375 3.1875 3.375ZM3.1875 12.375C2.565 12.375 2.0625 12.885 2.0625 13.5C2.0625 14.115 2.5725 14.625 3.1875 14.625C3.8025 14.625 4.3125 14.115 4.3125 13.5C4.3125 12.885 3.81 12.375 3.1875 12.375ZM5.4375 14.25H15.9375V12.75H5.4375V14.25ZM5.4375 9.75H15.9375V8.25H5.4375V9.75ZM5.4375 3.75V5.25H15.9375V3.75H5.4375Z" fill="black" fill-opacity="0.6"/>
					</svg>`
				},
				{
					class: 'ql-indent-1-button',
					classEx: 'ql-indent-1-button-ex',
					idRe: 'ql-indent-1-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
					<path d="M2.25 15.75H15.75V14.25H2.25V15.75ZM2.25 6V12L5.25 9L2.25 6ZM8.25 12.75H15.75V11.25H8.25V12.75ZM2.25 2.25V3.75H15.75V2.25H2.25ZM8.25 6.75H15.75V5.25H8.25V6.75ZM8.25 9.75H15.75V8.25H8.25V9.75Z" fill="black" fill-opacity="0.6"/>
					</svg>`
				},
				{
					class: 'ql-indentPlus1-button',
					classEx: 'ql-indentPlus1-button-ex',
					idRe: 'ql-indentPlus1-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
					<path d="M8.25 12.75H15.75V11.25H8.25V12.75ZM2.25 9L5.25 12V6L2.25 9ZM2.25 15.75H15.75V14.25H2.25V15.75ZM2.25 2.25V3.75H15.75V2.25H2.25ZM8.25 6.75H15.75V5.25H8.25V6.75ZM8.25 9.75H15.75V8.25H8.25V9.75Z" fill="black" fill-opacity="0.6"/>
					</svg>`
				},
				{
					class: 'ql-link-button',
					classEx: 'ql-link-button-ex',
					idRe: 'ql-link-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
					<path d="M12.75 5.25H9.75V6.75H12.75C13.9875 6.75 15 7.7625 15 9C15 10.2375 13.9875 11.25 12.75 11.25H9.75V12.75H12.75C14.82 12.75 16.5 11.07 16.5 9C16.5 6.93 14.82 5.25 12.75 5.25ZM8.25 11.25H5.25C4.0125 11.25 3 10.2375 3 9C3 7.7625 4.0125 6.75 5.25 6.75H8.25V5.25H5.25C3.18 5.25 1.5 6.93 1.5 9C1.5 11.07 3.18 12.75 5.25 12.75H8.25V11.25ZM6 8.25H12V9.75H6V8.25Z" fill="black" fill-opacity="0.6"/>
					</svg>`
				},
				{
					class: 'ql-script-button',
					classEx: 'ql-script-button-ex',
					idRe: 'ql-script-button-re',
					svg: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
					<path d="M14.6701 5.25H13.1701V6H15.4201V6.75H12.4201V5.25C12.4201 4.8375 12.7576 4.5 13.1701 4.5H14.6701V3.75H12.4201V3H14.6701C15.0826 3 15.4201 3.3375 15.4201 3.75V4.5C15.4201 4.9125 15.0826 5.25 14.6701 5.25ZM2.58008 15H4.57508L7.12508 10.935H7.21508L9.76508 15H11.7601L8.27258 9.5475L11.5276 4.5H9.51758L7.21508 8.2425H7.12508L4.80758 4.5H2.81258L6.05258 9.5475L2.58008 15Z" fill="black" fill-opacity="0.6"/>
					</svg>`
				}
			];

			buttons.forEach(bu => {
				let quillNormalUp = document.getElementsByClassName(bu.class)[0];
				let quillExpandedUp = document.getElementsByClassName(bu.classEx)[0];
				let quillReceitaUp = document.getElementById(`${bu.idRe}`);

				if (quillReceitaUp) quillReceitaUp.innerHTML = bu.svg;
				if (quillNormalUp) quillNormalUp.innerHTML = bu.svg;
				if (quillExpandedUp) quillExpandedUp.innerHTML = bu.svg;
			});
		};

		$scope.updateThemeQuill();

		// expandir mais formatações
		$scope.openMoreFormatting = () => {
			$scope.moreFormatting = true;

			$('#more-formatting .more-inf').css('transform', 'rotate(180deg)');

			$('#more-formatting div').removeClass('d-none');
		};

		// fechar formatações
		$scope.closeMoreFormatting = () => {
			$scope.moreFormatting = false;

			$('#more-formatting svg').css('transform', '');

			$('#more-formatting div').addClass('d-none');
		};

		$rootScope.setQuillEdit = value => {
			let delta = quill.clipboard.convert(value);

			quill.setContents(delta, 'silent');
		};

		// iniciar component
		$rootScope.initQuillEdit = (initialValue, id) => {
			setTimeout(() => {
				let editorId = `#editor-quill-edit-${id}`;
				let toolbarId = `#toolbar-container-quill-edit-${id}`;

				let div = document.getElementById(id).childNodes[0];

				let editor = div.children[2];
				let toolbar = div.children[1];

				editor.id = editorId.replace('#', '');
				toolbar.id = toolbarId.replace('#', '');

				// Verificar se já existe uma instância e limpá-la corretamente
				if (
					!quill.container ||
					(quill.container && quill.container.id != editorId.replace('#', ''))
				) {
					// Cria nova instância
					quill = new Quill(editorId, {
						modules: {
							toolbar: toolbarId
						},
						placeholder: 'Digite o texto',
						theme: 'snow'
					});

					// Chama quando alterar texto
					quill.on('text-change', (delta, old) => {
						if ($scope.limit !== 'none')
							$rootScope.updateErrorQuill(quill, old);

						let htmlContent = quill.root.innerHTML;

						$rootScope.configQuill.value = htmlContent;
					});

					quill.clipboard.addMatcher('img', () => {
						notification.danger(
							'Não é possível adicionar imagens ao campo selecionado.'
						);

						// Retorna um novo Delta vazio, ignorando a imagem
						return new Delta();
					});
				}

				// Altere a cor da borda do editor e da barra de ferramentas para a cor original
				$(quill.container).css('border-color', '');
				quill.getModule('toolbar').container.style.borderColor = '';

				// Remova a div de erro se o conteúdo estiver dentro do limite
				$('#error-message').remove();

				// Definir o valor inicial no editor
				$rootScope.configQuill.value = initialValue || '';

				$rootScope.setQuillEdit($rootScope.configQuill.value);
			}, 300);
		};

		$scope.resetQuillStatesEdit = () => {
			let delta = '';

			function isEmpty(obj) {
				return Object.keys(obj).length === 0 && obj.constructor === Object;
			}

			if (!isEmpty(quill)) {
				quill.setContents(delta, 'silent');

				// Altere a cor da borda do editor e da barra de ferramentas para a cor original
				$(quill.container).css('border-color', '');
				quill.getModule('toolbar').container.style.borderColor = '';
			}

			if (!isEmpty(quillExpanded)) {
				quillExpanded.setContents(delta, 'silent');

				$(quillExpanded && quillExpanded.container).css('border-color', '');

				quillExpanded.getModule('toolbar').container.style.borderColor = '';
			}

			// Remova a div de erro se o conteúdo estiver dentro do limite
			$('#error-message').remove();

			$scope.$resetFormValidation('editAgendaEvent')();
			$scope.$resetFormValidation('createEvent')();
		};

		setTimeout(() => {
			$('#modalEditAgendaEventComponent').on('hidden.bs.modal', () =>
				$scope.resetQuillStatesEdit()
			);

			$('#modalCreateExpense').on('hidden.bs.modal', () => {
				const element = document.getElementById('modalCreateExpense');
				const hasShowClass = element.classList.contains('show');

				// true se tiver a classe 'show', false caso contrário
				if (!hasShowClass) {
					$scope.resetQuillStatesEdit();
				}
			});
		}, 1000);
	}
]);

export default controller;
